<template>
    <transition name="showHeader">
        <div class="header-animat">
            <a-layout-header class="ant-layout-header ant-header-fixedHeader ant-header-side-closed" style="padding: 0;box-shadow:0px 1px 4px rgba(238,238,238,1);">
                <div  class="top-nav-header-index light">
                    <div class="header-index-wide" style="box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);">
                        <div class="header-index-left">
                            <logo/>
                            <header-menu ref="menu" style="margin:0 auto;"></header-menu>
                        </div>
                        <!-- <user-menu class="header-index-right"></user-menu> -->
                        <a-tooltip @click="goback" style="padding: 0 30px 0 0;font-size: 16px;cursor: pointer;color: #48b1ed;">
                            回到活动首页
                        </a-tooltip>
                    </div>
                </div>
            </a-layout-header>
        </div>
    </transition>
</template>
<script>
    import Logo from './Logo.vue'
    import HeaderMenu from './HeaderMenu.vue'
    import UserMenu from './UserMenu.vue'
    export default {
        name: 'GlobalHeader',
        components: {
            Logo,
            HeaderMenu,
            UserMenu
        },
        props: {},
        data () {
            return {
                visible: true,
                oldScrollTop: 0
            }
        },
        mounted () {
        },
        methods: {
            setIndex(){
                this.$refs.menu.setIndex();
            },
            goback(){
                this.$router.push({path: '/index'});
            }
        }
    }
</script>

<style lang="less" scoped="">

</style>
